import request from 'ykd-base/request'

export async function initWxShare(title: string, desc: string) {
  //@ts-ignore
  const wx: any = window.wx
  if (!wx) {
    return
  }

  const res: any = await request({
    method: 'GET',
    biz: 'done',
    url: `/share/wxjsmp?url=${encodeURIComponent(window.location.href)}`
  })

  wx.config({
    ...res.data
  })

  wx.ready(function() {
    const link = window.location.href
    const imgUrl = 'https://style.youkeda.com/img/ham/logo200.png'
    //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    wx.updateAppMessageShareData({
      title,
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function() {
        // todo 加打点
      }
    })
    //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.updateTimelineShareData({
      title,
      link,
      imgUrl,
      success: function() {
        // 设置成功
      }
    })
  })
}
